import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Crown, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface UpgradeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function UpgradeDialog({ open, onOpenChange }: UpgradeDialogProps) {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Crown className="h-5 w-5 text-primary" />
            Take Complete Control of Your Habits
          </DialogTitle>
          <DialogDescription>
            Unlock the full power of habit building with Premium. Get unlimited habits, 
            personalized colors, advanced insights, and everything you need to master your daily routine.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <h4 className="font-medium flex items-center gap-2">
              <Sparkles className="h-4 w-4 text-primary" />
              Master Your Habits with Premium
            </h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>✓ Unlimited habits for complete life control</li>
              <li>✓ Custom colors to stack your habits</li>
              <li>✓ Import your data from anywhere</li>
              <li>✓ Advanced analytics for deeper insights</li>
              <li>✓ Priority support when you need help</li>
              <li>✓ First access to powerful new features</li>
            </ul>
          </div>
          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={() => onOpenChange(false)}>
              Continue with Free
            </Button>
            <Button 
              onClick={() => {
                onOpenChange(false);
                navigate('/pricing');
              }}
            >
              Commit to Consistency
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
} 